import * as warning from 'warning';
import * as React from 'react';
import { createBrowserHistory as createHistory } from 'history';
import { Router } from 'react-router-dom';
// basename: PropTypes.string,
// forceRefresh: PropTypes.bool,
// getUserConfirmation: PropTypes.func,
// keyLength: PropTypes.number,
// children: PropTypes.node

const myhistory = createHistory();
const hybridGo = (path, state, method) => {
    if (!window.navigator.onLine) {
       console.log('不在线');
    } else {
        if (path.indexOf('mobile') > -1) {
            const posstart = path.indexOf('/', path.indexOf('mobile'));
            path = path.substr(posstart);
            myhistory[method](path, { from: 'hayner' });
        } else if (process && process.env.NODE_ENV === 'development') {
            const posstart = path.indexOf('/', path.indexOf('localhost'));
            path = path.substr(posstart);
            myhistory[method](path, { from: 'hayner' });
        } else {
            window.location.href = path;
        }
    }
};
window['webviewHistory'] = {
    clearRouter() {
        const n = 0 - myhistory.length + 1;
        myhistory.go(n);
    },
    go(n) {
        myhistory.go(n);
    },
    goBack() {
        myhistory.goBack();
    },
    goForward() {
        myhistory.goForward();
    },
    location: myhistory.location,
    push(path, state) {
        hybridGo(path, state, 'push');
    },
    replace(path, state) {
        hybridGo(path, state, 'replace');
    },
};
class BrowserRouter extends React.Component<any, any> {
    public componentWillMount() {
        console.log(this.props.children);
        warning(
            !this.props.history,
            '<BrowserRouter> ignores the history prop. To use a custom history, ' +
                'use `import { Router }` instead of `import { BrowserRouter as Router }`.'
        );
        myhistory.listen((location) => {
            // action, location.pathname, location.state
            console.log('lengthcount', myhistory.length);
            console.log('location', location);
            if (location.state && location.state.from === 'hayner') {
                window['chj-page-view-start'] = new Date();
            }
            // if(location.pathname==='/preload'){
            //     window.location.reload()
            // }
        });
    }

    public componentDidCatch(error, info) {
        console.log('componentDidCatch', error, info);
    }

    public render() {
        return <Router history={myhistory} children={this.props.children} />;
    }
}
export const history = myhistory;
export default BrowserRouter;
